import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

export const Container = styled.section<{ hide?: boolean }>`
    position: relative;
    display: ${({ hide }) => (hide ? 'none' : 'block')};
    margin: 8px 0;
    padding: 16px;
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
`;

export const CloseButton = styled(ButtonV2)`
    position: absolute;
    top: 16px;
    right: 16px;
    padding: 0px;
    background-color: ${({ theme }) => theme.colors['Level 1']};
    border: none;
`;

export const Title = styled.h4`
    ${(props) => props.theme.typography.SmallHeadline};
    display: flex;
    align-items: center;
    line-height: 32px;

    > span:not(:only-child):last-child {
        margin-left: 4px;
        align-self: center;
        flex: 0 0 16px;
        height: 26px;
    }
`;

export const Text = styled.p<{ grayText?: boolean }>`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme, grayText }) =>
        grayText ? theme.colors['Level 4'] : theme.colors['Level 5']};
    margin: 16px 0;
    line-height: 24px;
`;

export const List = styled.ul`
    display: flex;
    justify-content: space-between;
`;

export const ListCaption = styled.ul`
    display: flex;
    justify-content: space-between;

    p {
        margin: 4px 0 0;
        line-height: 24px;
    }
`;

export const MoodItem = styled.li<{ order?: number }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.colors['Level 1']};
    border-radius: 50%;
    order: ${({ order }) => order};
    cursor: pointer;
`;

export const Textarea = styled.textarea`
    margin: 24px 0;
    padding: 4px;
    resize: none;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
    background-color: ${({ theme }) => theme.colors.ElementBackground};
    border: 1px solid ${({ theme }) => theme.colors['Level 1']};

    &&:focus {
        outline: transparent;
    }
`;
